/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Do_Not_Type_The_Extension_EgInputs */

const en_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do not type the extension (e.g. .com)`)
};

const es_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No escribas la extensión (ej. .com)`)
};

const fr_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne tapez pas l'extension (ex. .com)`)
};

const de_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe nicht die Endung ein (z.B. .com)`)
};

const ja_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡張子は入力しないでください (例: .com は不要)`)
};

const zh_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请不要输入后缀 (例如 .com)`)
};

const ar_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا تكتب الامتداد (مثال: .com)`)
};

const id_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jangan ketik ekstensinya (mis. .com)`)
};

const it_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non digitare l'estensione (es. .com)`)
};

const ru_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вводите расширение (например, .com)`)
};

const pt_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não digite a extensão (ex. .com)`)
};

const ko_do_not_type_the_extension_eg = /** @type {(inputs: Do_Not_Type_The_Extension_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확장자를 입력하지 마세요 (예: .com)`)
};

/**
* | output |
* | --- |
* | "Do not type the extension (e.g. .com)" |
*
* @param {Do_Not_Type_The_Extension_EgInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const do_not_type_the_extension_eg = /** @type {((inputs?: Do_Not_Type_The_Extension_EgInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Do_Not_Type_The_Extension_EgInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_do_not_type_the_extension_eg(inputs)
	if (locale === "es") return es_do_not_type_the_extension_eg(inputs)
	if (locale === "fr") return fr_do_not_type_the_extension_eg(inputs)
	if (locale === "de") return de_do_not_type_the_extension_eg(inputs)
	if (locale === "ja") return ja_do_not_type_the_extension_eg(inputs)
	if (locale === "zh") return zh_do_not_type_the_extension_eg(inputs)
	if (locale === "ar") return ar_do_not_type_the_extension_eg(inputs)
	if (locale === "id") return id_do_not_type_the_extension_eg(inputs)
	if (locale === "it") return it_do_not_type_the_extension_eg(inputs)
	if (locale === "ru") return ru_do_not_type_the_extension_eg(inputs)
	if (locale === "pt") return pt_do_not_type_the_extension_eg(inputs)
	return ko_do_not_type_the_extension_eg(inputs)
});